import{usePrevious as r}from"../../hooks/usePrevious.js";const s=({resetErrorBoundary:s,messages:o})=>{const e=r(o);return e&&JSON.stringify(e)!==JSON.stringify(o)&&s(),null};export{s as ErrorFallback};
//# sourceMappingURL=ErrorFallback.js.map
